import React,{ Component } from "react";
import App from './pages/App';
import { BrowserRouter } from 'react-router-dom';
import axios from "axios";
import Properties from "./components/Properties";
import { NotificationManager } from 'react-notifications';
import './css/index.css';
import {GetAPPURL, IsPublicSite} from './common/functions';
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SFApp from "./SF/SFApp";
import { AppContext } from "./AppContext";
import ApiRequestService from "./components/ApiRequestService";
export default class MainApp extends Component{

    constructor(props){
        super(props);
        this.state = {
            appProperties: null,
            appSetting: null
        }
        this.appSettingCallBack = this.appSettingCallBack.bind(this);
    }

    componentWillMount = async () => {
    let universityPrefix = GetPrefixUniversity();
        if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
            await this.getAppSettings(this.appSettingCallBack)
        } else {
            window.localStorage.setItem(`${universityPrefix}_StudentAppsettings`, JSON.stringify({ ...process.env }));
            this.setState({appProperties :new Properties(),
                appSetting :JSON.parse(window.localStorage.getItem(`${universityPrefix}_StudentAppsettings`))});
        }

    }

    appSettingCallBack = (flag) => {
        let universityPrefix = GetPrefixUniversity();
        this.setState({appProperties :new Properties(),
            appSetting :JSON.parse(window.localStorage.getItem(`${universityPrefix}_StudentAppsettings`))});
    }

 
    getAppSettings = async (callBack) => {
        new Promise(async(resolve , reject) => {
            let AppURL = GetAPPURL();
    
            await axios.get(`${AppURL}/getStudentAppSettings`)
                .then(function (response) {
                    if (response?.data?.data) {
                        let universityPrefix = GetPrefixUniversity();
                        window.localStorage.setItem(`${universityPrefix}_StudentAppsettings`, JSON.stringify(response.data.data));
                        callBack(true);
                        resolve(true);
                    } else {
                        NotificationManager.error("App Setting Not Found", "ERROR!", 5000);
                        resolve(false);
                    }
                })
                .catch(function (error) {
                    console.log("App Settings Error:",error);
                    window.location = window.location.protocol + "//" + window.location.hostname + "/not-found.html";
                    reject(error);
                })
        })
    }


    render(){
        return this.state.appProperties && this.state.appSetting && <> <RouterLoad appProperties={this.state.appProperties} AppSetting={this.state.appSetting} /> {this.props.children} </>;
    }

        
}
  
class RouterLoad extends Component {
    constructor(props){
        super(props);

        this.params = new URLSearchParams(window.location.search)

        this.state = {
            selectedCourse: null,
            studentMode: false,
            studentEnrolledCourses: [],
            courseID: this.params.get("courseID") ? parseInt(this.params.get("courseID")) : null,

            selectedCategories: [],
            isPublicSite: false,
            isSpecialCourse: false,

            questionVectorsMapArr: {},
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const prevCourseId = prevState.selectedCourse?.course_id;
        const currentCourseId = this.state.selectedCourse?.course_id;

        if (prevCourseId !== currentCourseId) {
            if (this.state.isPublicSite && this.state.selectedCourse?.is_special_course) {
                if (this.state.isSpecialCourse !== true) {
                    this.setState({ isSpecialCourse: true });
                }
            } else {
                if (this.state.isSpecialCourse !== false) {
                    this.setState({ isSpecialCourse: false });
                }
            }
        }
    }

    componentDidMount() {
        // if (this.props.appProperties.enableLTI !== true) {
            this.getStudentCourses()
        // }
        
        this.setState({
            isPublicSite: IsPublicSite(),
        })
    }
    
    updateSelectedCourse = (selectedCourse) => {
        this.setState({
            selectedCourse
        })
    }

    updateStudentMode = (val) => {
        this.setState({
            studentMode: val,
        })
    }

    updateStudentEnrolledCourses = (courses) => {
        if (courses && courses.length) {
            this.setState({
                selectedCourse: courses[0],
                studentEnrolledCourses: courses,
            })  
        } else {
            this.setState({
                studentEnrolledCourses: [],
                selectedCourse: null,
            })
        }
    }

    getStudentCourses = () => {

        let courseID = this.params.get("courseID") ? parseInt(this.params.get("courseID")) : null;
        if (courseID === null || courseID === undefined) {
            courseID = window.localStorage.getItem("practiceCourseID", courseID);
        }

        const responsePromise = ApiRequestService({
            method: "POST",
            url: "/getStudentSectionEnrollment",
            data: {
                for_lti_practice: courseID ? true : false
            }
        });

        responsePromise.then(res => {
            if (res && res.data && res.data.data && res.data.data.enrollmentData) {
                if (res.data.data.enrollmentData && res.data.data.enrollmentData.length) {
                    
                    let selectedCourse = res.data.data.enrollmentData[0];

                    
                    if (courseID) {
                        window.localStorage.setItem("practiceCourseID", courseID);
                        let newCourse = res.data.data.enrollmentData.find(course => course.course_id === courseID);
                        if (newCourse) {
                            selectedCourse = newCourse;
                        }

                    } else {
                        let practiceCourseIDStr = window.localStorage.getItem("practiceCourseID");
                        if (practiceCourseIDStr) {
                            let practiceCourseID = parseInt(practiceCourseIDStr);
                            if (practiceCourseID) {
                                let newCourse = res.data.data.enrollmentData.find(course => course.course_id === practiceCourseID);
                                if (newCourse) {
                                    selectedCourse = newCourse;
                                }
                            }
                        }
                    }

                    console.debug("studentEnrolledCourses, courseID, selectedCourse >>>>>", res.data.data.enrollmentData, courseID, selectedCourse)
                    
                    this.setState({
                        studentEnrolledCourses: res.data.data.enrollmentData,
                        selectedCourse: selectedCourse
                    })
                }
            }
        })

    }

    onAddActivityLog = (payload) => {
        let newPayload = {
            ...payload,
            courseID: this.state.selectedCourse ? this.state.selectedCourse.course_id : 0,
        }

        console.debug("newPayload>>>", newPayload);

        let response = ApiRequestService({
            method: "POST",
            url: "/addStudentActivityLog",
            data: newPayload
        });
        response.then(res => {
            console.debug("res", res)
        }).catch(err => {
            console.debug("err", err)
        })
    }

    handleAddCategory = (cat) => {
        if (cat) {
            this.setState({
                selectedCategories: [...this.state.selectedCategories, cat]
            })
        }
    }

    handleAddCategories = (catArr) => {
        if (catArr && catArr.length) {
            this.setState({ 
                selectedCategories: [...this.state.selectedCategories, ...catArr]
            })
        }
    }

    handleClearCart = () => {
        this.setState({
            selectedCategories: [],
        })
    }

    updateQuestionVectorsMapArr = (key, arr) => {
        let tempQuestionVectorsMapArr = {...this.state.questionVectorsMapArr};
        tempQuestionVectorsMapArr[key] = arr;
        this.setState({
            questionVectorsMapArr: tempQuestionVectorsMapArr,
        })
    }

    handleRemoveCategory = (cat) => {
        
        let key = `${cat.subjectID}_${cat.topicID}_${cat.categoryID}`
        let index = this.state.selectedCategories.findIndex(selectedCat => {
            return `${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}` === key
        })

        console.debug("key>>>", key)

        if (index >= 0) {
            let updatedCategories = this.state.selectedCategories;
            updatedCategories.splice(index, 1)
            this.setState({
                selectedCategories: updatedCategories,
            })
        }
    }

    theme = createTheme({
        palette: {
            // mode: 'dark',
            primary: {
                main: '#bb0000',
                light: '#d20a0a',
                dark: '#d20a0a',
                contrastText: 'white',
            },
        },
        typography: {
            fontFamily: [
                "poppins",
            ],
            button: {
              textTransform: 'none',
              fontSize: 14,
            }
          },
          components: {
            MuiButtonBase: {
              defaultProps: {
                disableRipple: true, // Disable ripple effect for all ButtonBase components
              },
            },
            MuiButtonGroup: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiButton: {
            styleOverrides: {
              root: {
                borderRadius:"4px",
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
                '&:active': {
                  boxShadow: 'none',
                },
                '&:focus': {
                  boxShadow: 'none',
                },
              },
            },
        },
          },
      });
      

    render(){
        let uiSettings = this.props.appProperties.getUISettings();
        uiSettings.applyUIStyles();
        return ( 
            <AppContext.Provider
                value={{
                    selectedCourse: this.state.selectedCourse,
                    updateSelectedCourse: this.updateSelectedCourse,

                    studentMode: this.state.studentMode,
                    updateStudentMode: this.updateStudentMode,

                    studentEnrolledCourses: this.state.studentEnrolledCourses,
                    updateStudentEnrolledCourses: this.updateStudentEnrolledCourses,

                    onAddActivityLog: this.onAddActivityLog,

                    selectedCategories: this.state.selectedCategories,
                    handleAddCategory: this.handleAddCategory,
                    handleAddCategories: this.handleAddCategories,
                    handleRemoveCategory: this.handleRemoveCategory,
                    handleClearCart: this.handleClearCart,
                    
                    isPublicSite: this.state.isPublicSite,
                    isSpecialCourse: this.state.isSpecialCourse, //Public Assignment Library

                    // for showing question vectors in student canvas
                    questionVectorsMapArr: this.state.questionVectorsMapArr,
                    updateQuestionVectorsMapArr: this.updateQuestionVectorsMapArr,
                }}
            >
                <BrowserRouter basename={this.props.appProperties.baseName}>
                    <ThemeProvider theme={this.theme}>
                        {/* <App {...this.props} /> */}
                        <SFApp {...this.props} />
                    </ThemeProvider>
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        newestOnTop
                    />
                </BrowserRouter>
            </AppContext.Provider>
         )
    }
}

export function GetPrefixUniversity() {
    if (process.env.hasOwnProperty("REACT_APP_APPSETTING_REQUIRED")) {
        if (window.location.hostname === 'localhost') {
            return "local";
        } else {
            let hostArray = window.location.hostname.split(".");
            if (hostArray.length > 4) {
                return hostArray[hostArray.length - 5];
            } else if (hostArray.length == 4) {
                return hostArray[hostArray.length - 4];
            }
            return "local";
        }
    } else {
        return process.env.REACT_APP_UNIVERSITY_SUFFIX;
    }
}